export const DICTIONARY = {
  CHAT_TITLE: "Чат с банком",
  CHAT_SUB_TITLE: "Виртуальный помощник",

  OPPONENT_TYPING: "Оператор печатает…",

  UNREAD_MESSAGE_NOTIFICATION: "Новые сообщения",

  MESSAGE_PLACEHOLDER: "Написать сообщение...",
  SEARCH_PLACEHOLDER: "Поиск по сообщениям",

  POST_CHAT: "Чат создается...",

  DROPZONE_MESSAGE: "Переместите файлы",

  // MESSAGE_OPERATOR: "Оператор",
  MESSAGE_BOT: "Виртуальный помощник",

  ERRORS: {
    MAX_SIZE: "Слишком большой файл.\nРазмер файла до 10 Мб.",
    EXTENSION:
      "Неверный формат файла.\nПоддерживаются doc, jpeg, png, mp4 и др.",
  },

  CHAT_CREATE_ERROR: {
    TITLE: "Не удается создать чат",
    SUB_TITLE: "Пожалуйста, перезагрузите страницу или попробуйте позже",
  },

  CHAT_UNAVAILABLE: {
    TITLE: "Чат временно недоступен",
    SUB_TITLE: "Пожалуйста, обратитесь в контактный центр",
    PHONE: "8 (800) 100-78-70",
    PHONE_DESCRIPTION: "По России",
  },

  CHAT_EMPTY: {
    TITLE: "Оператор на связи",
    SUB_TITLE: "Пожалуйста, задайте ваш вопрос",
  },

  FILE: {
    DOWNLOAD: "Скачать",
    VIRUS: "Обнаружен вирус",
    ERROR: "Ошибка при загрузке файла",
    DOWNLOAD_LIMIT: "Загрузите не более 10 файлов",
    MAX_LIMIT: "Ошибка загрузки: максимум 10 файлов",
    INVALID_FILES: "Имеются невалидные файлы, они не будут отправлены",
    DISABLE_SENDING: "Отправка файлов отключена или недоступна",
  },

  MESSAGE_BUTTONS: {
    LIMIT: "В одном ряду должно быть не более 5 кнопок",
  },
  TAB_NEW_MESSAGE_TITLE: "Новое сообщение!",
};
